// Module
var code = "<style>:host{display:block}#cards{width:100%;height:140px;display:flex}</style> <radio-button></radio-button> <div id=\"cards\"> </div> ";
// Exports
export default code;